<!-- ======= Mobile nav toggle button ======= -->
<!-- <button type="button" class="mobile-nav-toggle d-xl-none">
  <i class="bi bi-list mobile-nav-toggle"></i>
</button>
<i class="bi bi-list mobile-nav-toggle d-xl-none"></i> -->
<!-- ======= Header ======= -->
<header id="header" class="d-flex flex-column justify-content-center">
  <nav id="navbar" class="navbar nav-menu">
    <ul>
      <li>
        <a href="#hero" class="nav-link scrollto"
          ><i class="bx bx-home"></i> <span>Home</span></a
        >
      </li>
      <li>
        <a href="#about" class="nav-link scrollto"
          ><i class="bx bx-user"></i> <span>Acerca de mí</span></a
        >
      </li>
      <li>
        <a href="#resume" class="nav-link scrollto"
          ><i class="bx bx-file-blank"></i> <span>Resumen</span></a
        >
      </li>
      <li>
        <a href="#portfolio" class="nav-link scrollto"
          ><i class="bx bx-book-content"></i> <span>Portafolio</span></a
        >
      </li>
      <li>
        <a href="#contact" class="nav-link scrollto"
          ><i class="bx bx-envelope"></i> <span>Contacto</span></a
        >
      </li>
    </ul>
  </nav>
  <!-- .nav-menu -->
</header>
<!-- End Header -->
